import { render, staticRenderFns } from "./InsightTopResult.vue?vue&type=template&id=4a3dcdee&scoped=true&"
import script from "./InsightTopResult.vue?vue&type=script&lang=ts&"
export * from "./InsightTopResult.vue?vue&type=script&lang=ts&"
import style0 from "./InsightTopResult.vue?vue&type=style&index=0&id=4a3dcdee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3dcdee",
  null
  
)

export default component.exports